import { oz } from '@weft/utils';
import { TierUsageDataInputSchema } from '../../../../../primitives';
import { ObjectIdSchema } from '../../../../../primitives/object-id-schema';

export const TiersUsageMapInputSchema = oz.record(
  ObjectIdSchema,
  oz.array(TierUsageDataInputSchema).nonempty(),
).openapi('TiersUsageMapInput');

export type TiersUsageMapInput = oz.infer<typeof TiersUsageMapInputSchema>;